<template>
  <div>
    <the-nav-bar :title="$t('createPost.tradeAmount')" />
    <div class="body-wrapper">
      <div class="field">
        <div class="field-item row-justify-center">
          <div class="field-item-title">
            {{ $t('customize.minTradeAmount') }}
          </div>
          <div class="field-item-content">
            <md-input-item
              type="number"
              v-model="minTradeAmount"
              v-input-mode="'decimal'"
              class="input-item"
              align="right"
              :readonly="isSubmitting"
            >
              <div class="unit" slot="right">{{ unit.unit }}</div>
            </md-input-item>
          </div>
        </div>
        <div class="field-item row-justify-center">
          <div class="field-item-title">
            {{ $t('customize.maxTradeAmount') }}
          </div>
          <div class="field-item-content">
            <md-input-item
              type="number"
              v-model="maxTradeAmount"
              v-input-mode="'decimal'"
              class="input-item"
              align="right"
              :readonly="isSubmitting"
            >
              <div class="unit" slot="right">{{ unit.unit }}</div>
            </md-input-item>
          </div>
        </div>
      </div>
      <div class="balance-info"  style="color:red;" v-if="this.balance == null && this.adTemp.adType=='sell'" >
        {{ $t('takeOrder.needBalance') }} {{ needBalance }} {{ asset.symbol }}
      </div>
      <div class="balance-info" v-if="balance" @click="onSellAll">
        {{ $t('takeOrder.balance') }}
        {{ balance.balance }} {{ asset.symbol }}
        <span v-if="balancePrice"> ≈ {{ balancePrice }} {{ unit.unit }} </span>
      </div>
      <div class="btn-group">
        <md-button
          :type="isConfirmBtnDisabled ? 'disabled' : 'primary'"
          @click="onConfirm"
        >
          <span>{{ $t('common.confirm') }}</span>
        </md-button>
      </div>
    </div>
  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import { Button, InputItem, Toast } from 'mand-mobile';
import { mapState } from 'vuex';
import toFixed from '@/utils/to-fixed.js';
import getCurrentPrice from '@/api/get-current-price';
export default {
  components: {
    'the-nav-bar': TheNavBar,
    [Button.name]: Button,
    [InputItem.name]: InputItem,
  },
  data() {
    return {
      minTradeAmount: '',
      maxTradeAmount: '',
      isSubmitting: false,
      price: '',
    };
  },
  computed: {
    ...mapState({
      isSettingsLoaded: state => state.settings.isSettingsLoaded,
      legalCurrencyList: state => state.settings.legalCurrencyList,
      cryptoList: state => state.settings.cryptoList,
      adTemp: state => state.adTemp,
      userAssets: state => state.userAssets, // 从客户端本地获取，如果以前有
    }),
    asset() {
      return this.cryptoList.find(item => item.id == this.adTemp.crypto);
    },
    needBalance() {
      if (this.balance==null &&this.price && this.maxTradeAmount) {
        return toFixed((this.maxTradeAmount/this.price)*(1+0.001), this.asset.exinDecimalDigit);
      }
      return null;  
    },
    balance() {
      if (this.asset && this.asset.uuid) {
        return (
          this.userAssets.find(item => item.assetUuid == this.asset.uuid) || null
        );
      }
      return null;
    },
    balancePrice() {
      if (this.price && this.balance) {
        return toFixed(this.balance.balance * this.price, this.unit.decimal);
      }
      return null;
    },
    isConfirmBtnDisabled() {
      return (
        !this.minTradeAmount ||
        !this.maxTradeAmount ||
        +this.minTradeAmount >= this.maxTradeAmount ||
        this.isSubmitting
      );
    },
    unit() {
      const { fiatCurrency } = this.adTemp;
      const obj = this.legalCurrencyList.find(item => {
        return item.id == fiatCurrency;
      });
      return obj || {};
    },
  },
  created() {
    const { fiatCurrency, tradeAmountMax, tradeAmountMin } = this.adTemp;
    if (!this.isSettingsLoaded || fiatCurrency === '') {
      Toast.failed(`${this.$t('error.occur')} ${this.$t('error.para')}`);
      return this.$router.replace('/exchange');
    }
    this.minTradeAmount = tradeAmountMin;
    this.maxTradeAmount = tradeAmountMax;

    if (this.adTemp.crypto) { //获取资产余额，已无法从接口获取，需改为js前端获取
      this.$store
        .dispatch('updateUserAssetSafe', this.asset.uuid)
        .catch(() => {});
    }

    if (this.adTemp.isFixed) {
      this.price = this.adTemp.fixedPrice;
    } else {
      this.loadReferencePrice().catch(() => {});
    }
  },
  methods: {
    onConfirm() {
      this.isSubmitting = true;
      this.$store.commit('setCreateTemp', {
        tradeAmountMin: this.minTradeAmount,
        tradeAmountMax: this.maxTradeAmount,
      });
      this.$nextTick(() => {
        this.isSubmitting = false;
        this.$router.back();
      });
    },
    onSellAll() {
      if (this.balancePrice && !isNaN(this.balancePrice)) {
        this.maxTradeAmount = toFixed(this.balancePrice / 1.00205, this.unit.decimal); //卖单应该考虑到0.2%手续费
      }
    },
    loadReferencePrice() {
      return getCurrentPrice(this.adTemp.crypto, this.adTemp.fiatCurrency)
        .then(data => {
          // 1 为exinOne
          let price;
          if (this.adTemp.reference == '1') {
            if (this.adTemp.type == 'buy') {
              price = +data.data.exin_buy_price || 0;
            } else {
              price = +data.data.exin_sell_price || 0;
            }
          } else {
            price = +data.data.price;
          }
          if (this.adTemp.isAbove) {
            price = price + +this.adTemp.difference;
          } else {
            price = price - this.adTemp.difference;
          }
          this.price = price;
        })
        .catch(err => Promise.reject(err));
    },
  },
};
</script>

<style lang="stylus" scoped>
.body-wrapper {
  padding: 6.4vw 4.8vw 30vw;
}

.field-item {
  height: 17.07vw;

  .field-item-title {
    flex: 0 0 45vw;
    font-size: 3.73vw;
    font-weight: bold;
  }

  .field-item-content {
    flex: 1 0 0;
  }

  .input-item {
    padding: 0 2.13vw;
    border: 0.27vw solid #eaf1f3;
    border-radius: 2.67vw;
    background: #f8f8fc;

    & >>> .md-field-item-content:before {
      content: none;
    }

    .unit {
      font-size: 3.73vw;
      color: color-primary;
    }
  }
}

.balance-info {
  color: #84969C;
  text-align: right;
  font-size: 2.67vw;
}

.btn-group {
  margin-top: 9.6vw;
}
</style>
